const processData = [
    {
      order: "01",
      type: "Scoping",
      title: "Project kickoff",
      description:
        "We outline the full scope, including features, integrations, and technical specifications. This phase ensures nothing is missed before development starts.",
    },
    {
      order: "02",
      type: "Development",
      title: "Strategic planning",
      description:
        "We build the website based on approved designs. This includes coding, integrating functionality, and setting up a staging site for review.",
    },
    {
      order: "03",
      type: "Content",
      title: "Defining the content",
      description:
        "We provide a content outline, help populate key pages with text, images, and assets, and train your team on the CMS.",
    },
    {
      order: "04",
      type: "Testing",
      title: "Launch ready",
      description:
        "A dedicated QA period to catch bugs, ensure cross-device compatibility, and optimise performance before launch.",
    },
  ];
  
  export default processData;
  